import React, { useEffect, useState } from "react"
import { Row, Col, Modal, Label, Input } from "reactstrap"
import "../../assets/scss/manual/manual.scss";
import avatar from "../../assets/images/users/avatar-1.jpg";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import axios from "axios";
import AppConfig from "../../constants/config";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast from 'react-hot-toast';

const EditAllocation = (prop) => {
    const { editOpen, setEditOpen, getAllocations, id, allocation, setSelectedAllocation } = prop
    const [loading, setLoading] = useState(false);

    const handleSubmit = async(values) => {
        setLoading(true)
        try {
            values.client_id = id
            values.id = allocation._id
            const {data} = await axios.post(`${AppConfig.baseUrl}/allocation/update_allocation`, values,{
                headers:{token: localStorage.getItem('token')}
            });
            if(!data.error){
                toast.success('Allocation updated successfully');
                getAllocations({});
                handleCloseDialog();
            }
            else{
                throw new Error(data.title);
            }
        } catch (error) {
            toast.error(error.message || 'Something went wrong');
        }
        setLoading(false)
    }

    const handleCloseDialog = () => {
        formik.resetForm();
        setEditOpen(false);
    }
  
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
        },
        validationSchema: Yup.object({            
            title: Yup.string().required("Please enter title"),         
        }),
        onSubmit: handleSubmit
    });
    
    useEffect(() => {
        if(allocation){
            formik.setValues({
                title: allocation.title || '',
            })
        }
    }, [allocation])

    return (
        <Modal
            isOpen={editOpen}
            toggle={() => {
                setEditOpen(false);
                setSelectedAllocation({})
            }}
            size="md"
            centered
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0">Add Allocation</h5>
                <button
                    type="button"
                    onClick={() => {
                        setEditOpen(false);
                        setSelectedAllocation({})
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <form onSubmit={formik.handleSubmit}>
                    <Row>
                        <Col lg={12} md={12} xl={12} xxl={12}>
                            <div>
                                <Label for="title" className="col-form-label">
                                    Title:
                                </Label>
                                <Input
                                    type="text"
                                    id="title"
                                    name="title"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.title || ""}
                                />
                                {formik.touched.title && formik.errors.title &&
                                    <div className="text-danger">{formik.errors.title}</div>
                                }
                            </div>
                        </Col>
                    </Row>
                    <div className="modal-footer mt-3">
                        <button type="submit" className="btn btn-lbusers" disabled={loading} >
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            SUBMIT
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default EditAllocation